<template>
    <DBox
            :id="'cmp-catalog-releases-sidewindow-costs'"
            :addButton="false"
            :addLink="true"
            :addLinkLabel="$t('add_new')"
            :rightMenu="[
              {
                text: $t('account_click'),
                value: 'account_click',
              },
            ]"
            @menuClick="onRightMenuClick"
    >



      <div class="body-container">
        <div class="ut-flex">
          <div class="product-search">
            <InputField
              :id="'product_search'"
              :value="searchString"
              :placeholder="$t('search')"
              :config="{
                borderStyle: 'bottom',
                width: '128px',
              }"
              @keyup="onSearchInputKeyup"
            ></InputField>
          </div>
          <div class="dropdown-panel-area ut-flex">
            <div class="filter-dropdown">
              <Dropdown
                :options="formatsTV"
                v-if="formatsTV && formatsTV.length > 0"
                :selected="formatsTV.find(f => f.value == format_id)"
                :placeholder="$t('select_format')"
                deselect
                borderbottom
                @selectedChange="e => onDropdownChange('format_id', e)"
              ></Dropdown>
            </div>
 
          </div>
        </div>
        <NTable
          id="catalog-product_groups-add_products"
          class="h1 dbox1"
          :config="tableConfig"
          :headers="headers"
          :items="list"
          >
          <template v-slot:item="{ item, tdcon }">
            <tr>
              <td v-bind="tdcon('related_costs')">
                <span class="txtov" >
                  {{ item["date"] }}
                </span>
              </td>            
              <td v-bind="tdcon('description')">
                <span class="txtov" >
                  {{ item["description"] }}
                </span>
              </td>            
              <td v-bind="tdcon('autobalance_royalty_cost_groups')">
                <span class="txtov" >
                  {{ item["cost_group_name"] }}
                </span>
              </td>            
              <td v-bind="tdcon('ignore')">
                  <div class="ut-rowcen">
                    <div class="dt-checkbox v2 s1">
                      <input
                        type="checkbox"
                        :name="`exclude-${item['hold_flag']}`"
                        :id="`exclude-${item['hold_flag']}`"
                        :checked="item['hold_flag'] == '1'"
                        @click="(e) => onHold(e, item)"
                      />
                      <div class="checkmark"></div>
                    </div>
                  </div>
              </td>            
     
              <td v-bind="tdcon('amount_iso')">
                <span v-if="item['amount_orig_curr']" class="txtov" >
                  {{ item["amount_orig_curr"] +"" +item["currency"] }}
                </span>
                <span v-else>
                    {{ item["currency"] }}
                </span>
              </td>  
               <td v-bind="tdcon('amount_eur')">
                <span class="txtov" >
                  {{ item["amount_orig_curr"] }}
                </span>
              </td>     
              <td v-bind="tdcon('recoupment')">
                <span class="txtov" >
                  {{ item["recoupable_txt"] }}
                </span>
              </td>         
              <td v-bind="tdcon('options')">
                    <div class="dt-icon-container">
                          <img
                            @click.stop="(e) => deleteCost(item)"
                            src="static/icons/delete.svg"
                            class="dt-icon v5 s2"
                          />
                     </div>
              </td>
            </tr>
          </template>
        </NTable>
      </div>
    
     </DBox>
   


  
</template>

<script>
import Modal from '@dtplugins/modal/modal';
import NTable from "@/plugins/datatable/datatable";
import { EventHooks } from '../../../../plugins/text-field'; 
import { ProductGroupsService } from '../../services/product-groups.service';
import { async } from 'rxjs/internal/scheduler/async';
import { createNTableConfig, createTableHeader } from '../../../../plugins/datatable';
import InputField from "@plugins/text-field/input-field";
import { createTV } from '../../../../models/text-value.model';
import { subscribeSubject } from '../../../../utility';
import { Subject } from 'rxjs';

export default {
  components: {
    Modal,
    NTable,
    InputField,
  },
  props: {
    costItems:{
     type:Array,
     default:()=>[]
    },
    costDropDownItems:{
     type:Array,
     default:()=>[]
    },
    selectedReleaseDetails: {
        type: Object,
    },
    costOrIncomeFlag:{
      type:String
    }
  },
  data() {
    return {
      labels: [],
      formats: [],
      productList: [],

      label_id: '',
      format_id: '',
      searchString: '',
      searchSubject: new Subject(),
      selectedProducts: new Set(),

      selectAllFlag: false,
    }
  },
  mounted: async function () {
    // Product-Groups Subscription
    subscribeSubject(this, this.searchSubject, () => {
      this.findProductList();
    });

    const res = await ProductGroupsService.fetchProductFormatsList();
    // console.log('Formats ', res.data);
    this.formats = res.data.formats;
    // console.log('Formats array ', this.formats);

    this.labels = res.data.labels;
    // console.log('Labels array ', this.labels);
  },
  computed: {
    tableConfig: function () {
      return createNTableConfig({
        headerStyle: 3,
        rowHeight: 28,
        fullHeight: true,
      });
    },
    list: function () {
      if(this.costOrIncomeFlag=='related_costs'){
        return this.selectedReleaseDetails.costs||[];  
      }
      else if(this.costOrIncomeFlag=='related_other_income'){
        return this.selectedReleaseDetails.other_incomes||[]
      }

      return []
      
    },
    product_group_id: function () {
      return this.$route.params.product_group_id;
    },
    formatsTV() {
      return createTV(this.formats, 'format_name', 'format_id');
    },
    labelsTV() {
      return createTV(this.labels, 'label_name', 'label_id').filter(e => e.text != '');
    },
    headers: function () {
      return [
        createTableHeader(this.costOrIncomeFlag,{}),
        createTableHeader("description",{}),
        createTableHeader("autobalance_royalty_cost_groups", {  }),
        createTableHeader("ignore",{ mw:50}),
        createTableHeader("amount_iso",{ text:"Amount ISO"}),
        createTableHeader("amount_eur",{ text:"Amount EUR"}),
        createTableHeader("recoupment",{}),
        createTableHeader("options", { text: false ,mw:30}),
      ];
    },
  },  
  methods: {
    findProductList: function() {
      ProductGroupsService.fetchProductFilterList(this.product_group_id, this.searchString, this.label_id, this.format_id ).then(productList => {
        // console.log(productList);
        this.productList = productList.data.products || [];
      });
    },
    onAddProducts: async function () {
      // console.log("OK", this.selectedProducts);
      const res = await ProductGroupsService.addProducts(this.product_group_id, `[${Array.from(this.selectedProducts).map(e => '"' + e + '"')}]`);
      // console.log('Add Products ', res.data);
      this.$emit('added', {
        value: res.data.products
      });
    },
    onSelectAll: function() {
      if (!this.selectAllFlag) {
        this.selectedProducts = new Set(this.list.map(i => i['product_id']));
        this.selectAllFlag = true;
      } else {
        this.selectAllFlag = false;
        this.selectedProducts = new Set();
      }
      // this.emitSelected();
    },

    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onSearchInputKeyup: function (e) {
      this.searchString = e.target.value;
      // console.log(this.searchString, e.target.value);
      this.searchSubject.next(this.searchString);
    },
    onDropdownChange(name, value) {
      this[name] = value.value;
      this.findProductList();
    },
    onProductSelected: function (e, item) {
      // console.log('checkbox')
      if (e.target.checked) {
        this.selectedProducts.add(item.product_id);
      } else {
        this.selectedProducts.delete(item.product_id);
      }
    },
    onRightMenuClick:function(menu){

    },
    onHold:function(e,item){
      let check='unchecked'
      if(e.target.checked)
      {
        check='checked'
      }
      const payload={ hold_flag:check ,cost_split_id:item.cost_split_id,name:this.costOrIncomeFlag}
      this.$emit('change',payload)
      // console.log("WWWW",e.target.checked)
    },

    deleteCost:function(item){
        const payload={ cost_split_id:item.cost_split_id,name:this.costOrIncomeFlag}
        this.$emit('delete',payload)
    }

  }
}
</script>

<style lang="scss">
.cmp-catalog-releases-sidewindow-costs{

   .ut-flex{
       padding: 10px 10px 0px 10px;
   } 
   
  .product-search,
  .dropdown-panel-area {
    margin-bottom: 30px;
  }
  .product-search {
    flex: 1;
    margin-top:10px ;
  }
  .dropdown-panel-area {
    justify-content: flex-end;
    .filter-dropdown {
      flex: 1;
      padding-right: 10px;

      &:last-child {
        padding-right: 0;
        padding-left: 10px;
      }
      .dropdown{
        width: 128px;
      }
    }
  }
  .catalog-product_groups-add_products {
    border: 1px solid var(--sprt-5);
  }
}
</style>